export interface Props {
  label: string;
  error?: string;
  showLabel?: boolean;
}

const Label = ({ label, error, showLabel }: Props) => (
  <label
    style={{
      color: error ? 'var(--c-red-400)' : 'inherit',
    }}
    className={error ? 'error' : ''}
    htmlFor={label}
  >
    {showLabel ? label : ''}
    {!!error && ` ${error}`}
  </label>
);

export default Label;
